// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const SummonAutocomplete = function($timeout: any, $compile: any, $rootScope: any) {
   return {
      scope: {
         searchUrl: '=',
         onResponse: '&',
         minChars: '=',
         onSelect: '&?'
      },
      link(scope: any, elem: any, attrs: any) {
         const settings = {
            url: scope.searchUrl,
            minChars: scope.minChars || 3,
            markAsBold: false,
            grouped: true,
            groupTemplate: "<li class='autocomplete-group' ng-class='::data.groupClass'><ul class='autocomplete-items' role='listbox' /></li>",
            onSelect(el: any, value: any): any {
               // get the first non-highlighted version of the query
               const {
                  // @ts-expect-error TS(2339) FIXME: Property 'data' does not exist on type 'IScope'.
                  data
               } = angular.element(el).scope()
               if (angular.isFunction(scope.onSelect)) { 
                  return scope.onSelect({data})
               } else { 
                  const searchTerm = data.text_orig || data.hitAliases?.[0] || data.text || ( data.type === 'azlist' ? data.name : undefined )
                  return angular.element(this).val(searchTerm).focus().trigger('change')
               }
            },
            templateMethod(template: any, jsonData: any) {
               // create new isolate scope and compile the angular template
               const newScope = $rootScope.$new(true)
               newScope.data = jsonData
               const newElem = $compile(template)(newScope)
               newScope.$digest()
               return newElem
            }
         }

         return $timeout(() => angular.element("#" + attrs.summonAutocomplete)
            // @ts-expect-error TS(2339) FIXME: Property 'tinyAutocomplete' does not exist on type... Remove this comment to see the full error message
            .tinyAutocomplete(settings)
            .on('receivedata', (evt: any, tinyAutocomplete: any, response: any) => tinyAutocomplete.json = scope.onResponse({json: response})))
      }
   }
}

const TopicsTemplate = (i18n: any) => ({
   replace: true,
   templateUrl: '/assets/autocomplete/topics.html',

   link(scope: any, elem: any, attrs: any) {
      scope.i18n = i18n
      return scope.relatedTopicClick = (topic: any) => scope.data.text = topic
   }
})

const BestBetsTemplate = (i18n: any) => ({
   replace: true,
   templateUrl: '/assets/autocomplete/bestBets.html',

   link(scope: any, elem: any, attrs: any) {
      return scope.i18n = i18n
   }
})

const DBRecsTemplate = (i18n: any) => ({
   replace: true,
   templateUrl: '/assets/autocomplete/dbRecs.html',

   link(scope: any, elem: any, attrs: any) {
      return scope.i18n = i18n
   }
})

const PopularSearchesTemplate = (i18n: any) => ({
   replace: true,
   templateUrl: '/assets/autocomplete/popularSearches.html',

   link(scope: any, elem: any, attrs: any) {
      return scope.i18n = i18n
   }
})

const AzSearchTemplate = (i18n: any) => ({
   replace: true,
   templateUrl: '/assets/autocomplete/azSearch.html',

   link(scope: any, elem: any, attrs: any) {
      return scope.i18n = i18n
   }
})

angular.module('summonApp.directives')
   .directive('summonAutocomplete', ['$timeout', '$compile', '$rootScope', SummonAutocomplete])
   .directive('topicsTemplate', ['translationService', TopicsTemplate])
   .directive('bestBetsTemplate', ['translationService', BestBetsTemplate])
   .directive('dbRecsTemplate', ['translationService', DBRecsTemplate])
   .directive('popularSearchesTemplate', ['translationService', PopularSearchesTemplate])
   .directive('azSearchTemplate', ['translationService', AzSearchTemplate])
